import { useEffect } from 'react';

export function usePageMeta(title:string,description:string,canonical?:string){
  useEffect(()=>{
    document.title=title;
    const ensureMeta=(selector:string,attr:string,key:string,value:string)=>{
      let node=document.querySelector(selector) as HTMLMetaElement|null;
      if(!node){node=document.createElement('meta');node.setAttribute(attr,key);document.head.appendChild(node)}
      node.content=value;
    };
    ensureMeta('meta[name="description"]','name','description',description);
    ensureMeta('meta[property="og:title"]','property','og:title',title);
    ensureMeta('meta[property="og:description"]','property','og:description',description);
    if(canonical){
      ensureMeta('meta[property="og:url"]','property','og:url',canonical);
      let link=document.querySelector('link[rel="canonical"]') as HTMLLinkElement|null;
      if(!link){link=document.createElement('link');link.rel='canonical';document.head.appendChild(link)}
      link.href=canonical;
    }
    const theme=document.querySelector('meta[name="theme-color"]') as HTMLMetaElement|null;
    if(theme)theme.content='#111019';
  },[title,description,canonical]);
}
